import {
  GIF_MASONRY_COLS,
  GIF_MASONRY_GAPS,
  GIF_MASONRY_SKELETON_HEIGHTS,
} from "../constants";
import { GifSkeleton } from "./gif-skeleton";

const COLS = GIF_MASONRY_COLS;
const GAPS = GIF_MASONRY_GAPS;
const HEIGHTS = GIF_MASONRY_SKELETON_HEIGHTS;

export const GifsSkeleton = ({ noAnim }: { noAnim?: boolean }) => {
  return (
    <div
      className="tw-grid tw-size-full tw-grid-flow-col tw-overflow-hidden tw-px-6"
      style={{ columnGap: GAPS }}
    >
      {Array.from({ length: COLS }, (_, idx) => (
        <ColSkeleton
          key={idx}
          heights={HEIGHTS[idx % HEIGHTS.length]}
          noAnim={noAnim}
        />
      ))}
    </div>
  );
};

const ColSkeleton = ({
  heights,
  noAnim,
}: {
  heights: number[];
  noAnim?: boolean;
}) => {
  return (
    <ul className="tw-mt-4 tw-grid tw-list-none tw-content-start tw-gap-2">
      {Array.from({ length: 12 }, (_, idx) => (
        <li
          key={idx}
          style={{
            height: heights[idx % heights.length],
          }}
        >
          <GifSkeleton noAnim={noAnim} />
        </li>
      ))}
    </ul>
  );
};
